<div class="employee-dropdown-host position-relative"></div>
<div class="modal-header">
    <h4 class="modal-title fs-5 text-reset text-capitalize">Medarbejdere</h4>
    <button (click)="onDismiss()" type="button" class="btn-close" data-bs-theme="dark" aria-label="Luk"></button>
</div>

<div class="bg-white border-bottom p-2 d-flex flex-wrap align-items-center gap-2">
    <input type="search" class="form-control form-control-sm employee-search mw-100" aria-label="Søg medarbejder"
           placeholder="Søg medarbejder…" [ngModel]="search()" (ngModelChange)="search.set($event)">
    <button (click)="normTiderPopup()" class="btn btn-primary btn-sm" type="button">Normtider</button>
    <button (click)="afdelingerPopup()" class="btn btn-primary btn-sm" type="button">Afdelinger</button>
    <button (click)="grupperPopup()" class="btn btn-primary btn-sm" type="button">Grupper</button>
    <div class="form-check ms-auto mb-0 text-nowrap">
        <input class="form-check-input" type="checkbox" id="visFratraadte" (change)="changeShowAll()" [checked]="showAll()">
        <label class="form-check-label" for="visFratraadte">Vis fratrådte</label>
    </div>
</div>
@if (indexCardsStore.loading()) {
    <div class="p-3" role="status">Indlæser medarbejdere…</div>
} @else if (indexCardsStore.loadError()) {
    <div class="p-3" role="alert">Medarbejderdata kunne ikke indlæses.
        <button type="button" class="btn btn-primary btn-sm ms-2" (click)="indexCardsStore.init()">Prøv igen</button>
    </div>
} @else {
@if (!rateColumns().length) {
    <div class="alert alert-warning rounded-0 mb-0 py-2" role="status">Der er ingen navngivne timesatser. Angiv navnene i indstillingerne.</div>
}
<div class="modal-body employee-scroll flex-shrink-1 overflow-auto p-0" (scroll)="closeDropdowns()">
    <table class="table medarbejdere-table table-hover table-sm text-nowrap align-middle mb-0">
        <thead>
        <tr>
            <th scope="col" class="py-1 px-2 fw-medium position-sticky top-0 bg-light z-3 employee-init start-0 text-center">Init</th>
            <th scope="col" class="py-1 px-2 fw-medium position-sticky top-0 bg-light z-2 employee-field">Navn</th>
            <th scope="col" class="py-1 px-2 fw-medium position-sticky top-0 bg-light z-2 employee-field">Titel</th>
            <th scope="col" class="py-1 px-2 fw-medium position-sticky top-0 bg-light z-2 employee-field">Tlf</th>
            <th scope="col" class="py-1 px-2 fw-medium position-sticky top-0 bg-light z-2 employee-field">Mobil</th>
            <th scope="col" class="py-1 px-2 fw-medium position-sticky top-0 bg-light z-2 employee-field">Email</th>
            <th scope="col" class="py-1 px-2 fw-medium position-sticky top-0 bg-light z-2 employee-flag text-center">SA</th>
            <th scope="col" class="py-1 px-2 fw-medium position-sticky top-0 bg-light z-2 employee-flag text-center">KA</th>
            <th scope="col" class="py-1 px-2 fw-medium position-sticky top-0 bg-light z-2 employee-flag text-center">LA</th>
            @for (rate of rateColumns(); track rate.ts) {
                <th scope="col" class="py-1 px-2 fw-medium position-sticky top-0 bg-light z-2 employee-rate text-end">Timesats: {{ rate.name }}</th>
            }
            <th scope="col" class="py-1 px-2 fw-medium position-sticky top-0 bg-light z-2 employee-level">Level</th>
            <th scope="col" class="py-1 px-2 fw-medium position-sticky top-0 bg-light z-2 employee-field">Ansat</th>
            <th scope="col" class="py-1 px-2 fw-medium position-sticky top-0 bg-light z-2 employee-field">Fødselsdato</th>
            <th scope="col" class="py-1 px-2 fw-medium position-sticky top-0 bg-light z-2 employee-field">Fratrådt</th>
            <th scope="col" class="py-1 px-2 fw-medium position-sticky top-0 bg-light z-2 employee-field">Afdelinger</th>
            <th scope="col" class="py-1 px-2 fw-medium position-sticky top-0 bg-light z-2 employee-field">Grupper</th>
        </tr>
        </thead>
        <tbody class="border-top-0">
            @for (user of sortedUsers(); track user.cardId) {
                <tr app-medarbejder [user]="user" [rateColumns]="rateColumns()"></tr>
            } @empty {
                <tr><td [attr.colspan]="15 + rateColumns().length" class="p-3 text-center">Ingen medarbejdere matcher søgningen.</td></tr>
            }
        </tbody>
    </table>
</div>

}
